import React, { FC } from 'react'

//* utils
import { ModuleNames } from '../../../constants/componentNames.constants'
import { LocaleCodes } from '../../../constants/localization.constants'
import { ComponentAnnouncement } from '../../../models/components/announcement'
import { ComponentMainNavBanner } from '../../../models/components/mainNavBanner'
import { MenuGroup } from '../../../models/others/menuGroup'
import { findTarget } from '../../../utils/microcopy.utils'

//* components
import Layout from '../../layouts/layout'
import { Modules } from './modules'

type Props = {
  path: string
  pageContext: any
  location?: any
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  footerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  announcementData?: ComponentAnnouncement
  mainNavBannerData?: ComponentMainNavBanner
  browserLanguageData?: any
}

const ResourceDemoPage: FC<Props> = ({
  path,
  pageContext,
  location,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}) => {
  if (!pageContext.resourceDemoData) return null
  const { microcopy, slug } = pageContext.resourceDemoData
  const defaultLocale = pageContext.pageLocale || LocaleCodes.ENGLISH.code
  const generics = microcopy?.values || []

  let relatedDemos = pageContext.relatedResourceDemos || []
  let dynamicRow: any
  let dynamicContent: any

  if (pageContext.relatedResourceDemo) {
    relatedDemos = pageContext.relatedResourceDemo.map((ele: any) => {
      return {
        hero: ele.hero || {},
        teaserBody: ele.teaserBody || '',
        seoMetadata: ele.seoMetadata || {},
        category: ele.resourceCategory || { name: 'Video Demo', number: '6' },
        microcopy: ele.microcopy || {},
        spotlight: ele.spotlight || {},
        slug: ele.slug || '',
        __typename: ele.__typename,
      }
    })

    dynamicRow = {
      __typename: ModuleNames.RESOURCE_ROW,
      topPadding: 'Small',
      bottomPadding: 'Small',
      featuredPages: relatedDemos,
    }

    dynamicContent = {
      bottomPadding: 'None',
      contentBlockTheme: 'Grey',
      headline: findTarget(`.relatedVideos.text`, generics, false) || 'Related video demos',
      orangeDivider: false,
      textAlignment: true,
      topPadding: 'Small',
    }
  }

  return (
    <Layout.Template
      lang={defaultLocale}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}
      pageType="resourceDemo"
      slug={slug || '/'}
      availableLocales={pageContext.availableLocales}>
      <Modules
        data={pageContext.resourceDemoData}
        relatedDemos={relatedDemos}
        dynamicContent={dynamicContent}
        dynamicRow={dynamicRow}
        generics={generics}
        availableLocales={pageContext.availableLocales}
        locale={defaultLocale}
        path={path}
        location={location}
      />
    </Layout.Template>
  )
}

export default ResourceDemoPage
